import React, { useEffect } from 'react';
import { ClassProvider } from './contexts/classContext';
import Layout from './components/common/layout/layout';
import { Helmet } from 'react-helmet';

const AppLayout = () => {
  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon && process.env.REACT_APP_FAVICON_URL) {
      favicon.href = process.env.REACT_APP_FAVICON_URL;
    }
  }, []); // Run only on mount

  return (
    <>
      <Helmet>
        <title>{process.env.REACT_APP_TITLE || ''}</title>
      </Helmet>
      <ClassProvider>
        <Layout />
      </ClassProvider>
    </>
  );
};

export default AppLayout;
